import { render, staticRenderFns } from "./over_transfer.vue?vue&type=template&id=3d446325"
import script from "./over_transfer.vue?vue&type=script&lang=js"
export * from "./over_transfer.vue?vue&type=script&lang=js"
import style0 from "./over_transfer.vue?vue&type=style&index=0&id=3d446325&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports